import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import { getVehicleCreateOptions, getVehicleCreateAccomodations } from 'src/state/actions/vehicles'
import GlobalSettingsPane from 'src/components/global-settings/GlobalSettingsPane'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    getVehicleCreateOptions: () => {
      return new Promise((approve, reject) => {
        dispatch(getVehicleCreateOptions()).then(() => {
          dispatch(getVehicleCreateAccomodations()).then(() => {
            approve()
          })
        })
      })
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalSettingsPane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/GlobalSettingsPane.ts